import React from 'react';
import withView from '../../../cmn/docAutomation/withView';
import DashSCRow from './DashSCRow';

const DashShortCuts = (props) => {
    const { formObject, viewData, deviceInfo } = props;
    
    if (!viewData)
        return (null);
    
    let data = formObject.getFormRow("","DashSC");

    return (
        <div className={`${deviceInfo.activateMobileView ? 'uiSelectedChipTrans' : 'uiViewActivatorBlue'} `}>
            <ul className="uiFlexBox">
                {
                    Object.values(data.rowValues).map((row, index) => (
                        <DashSCRow formObject={formObject} rowKey={row.key} viewData={row} key={index} />
                    ))
                }
            </ul>
        </div>
    )
}

export default withView(DashShortCuts, "dashShortcuts", "")

